import { EntCompany } from "./company";
import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";

export class EntCompanyWarehouses {
  id: number | null = null;
  warehouseName: string | null = null;
  fio: string | null = null;
  phone: string | null = null;
  company:EntCompany | null = null;
  regionRu: string | null = null;
  regionKy: string | null = null;
  areaRu: string | null = null;
  areaKy: string | null = null;
  territorialUnit:EntTerritorialsUnits | null = null;
  address: string | null = null;
  longitude: number | null = null;
  latitude: number | null = null;

  companyId?: number | null;
  territorialUnitId?: number | null;

  regionId: number | null = null
  areaId: number | null = null

  territorialUnitArea:EntTerritorialsUnits | null = null;
  territorialUnitRegion:EntTerritorialsUnits | null = null;
}